/**
 * Hold reasons live on the order as notes. investing-service writes
 * "On hold: <reason>" when an admin holds an order, and users-service writes
 * the same when a wallet freeze holds a customer's orders. Notes come back
 * newest first, so the first match is the reason for the current hold.
 *
 * Contract (investing-service holdOrder): `reason` is required, non-empty and
 * at most 500 characters when `hold` is true; optional on release.
 */
export const HOLD_REASON_MAX_LENGTH = 500;
export const HOLD_BULK_LIMIT = 50;

const HOLD_PREFIX = 'On hold:';

export const latestHoldReason = notes => {
  const note = (notes || []).find(
    n => typeof n?.note === 'string' && n.note.startsWith(HOLD_PREFIX),
  );
  return note ? note.note.slice(HOLD_PREFIX.length).trim() || null : null;
};

/** The form error for a reason, or null when it is acceptable. */
export const holdReasonError = (reason, hold) => {
  const value = (reason || '').trim();
  if (hold && !value) return 'Give a reason for putting the order(s) on hold.';
  if (value.length > HOLD_REASON_MAX_LENGTH) {
    return `Keep the reason to ${HOLD_REASON_MAX_LENGTH} characters or fewer.`;
  }
  return null;
};

/** The holdOrder input; a blank release reason is left out entirely. */
export const buildHoldInput = ({orderIds, hold, reason}) => {
  const value = (reason || '').trim();
  return {
    orderIds,
    hold,
    ...(value ? {reason: value} : {}),
  };
};
